export default "__VITE_ASSET__DLZf0bXp__"